import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from './i18n'
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/font/fonts.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VYearCalendar from 'v-year-calendar';
Vue.config.productionTip = false;
Vue.use(VYearCalendar);
Vue.use(VueSweetalert2);
new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
